export default "__VITE_ASSET__DwncAJsg__"